import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailQuestion } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-12 sm:py-16 lg:py-20 flex justify-center" data-testid="forgot-password-page">
      <div className="w-full max-w-md px-4">
        <Card className="border-slate-200">
          <CardContent className="p-6 sm:p-8 space-y-5">
            <div className="h-12 w-12 rounded-2xl bg-sky-100 flex items-center justify-center">
              <MailQuestion className="h-6 w-6 text-sky-700" />
            </div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900" data-testid="forgot-password-title">Mot de passe oublié</h1>
            {sent ? (
              <div className="space-y-4" data-testid="forgot-password-confirmation">
                <p className="text-sm leading-relaxed text-slate-600">
                  Si cet email est enregistré, un lien de réinitialisation vient d'être envoyé.
                  Il est valable 1 heure.
                </p>
                <Button variant="outline" className="w-full" asChild data-testid="back-to-login-btn">
                  <Link to="/connexion">Retour à la connexion</Link>
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <p className="text-sm text-slate-600">Saisissez votre email pour recevoir un lien de réinitialisation.</p>
                <div className="space-y-2">
                  <Label htmlFor="forgot-email">Email</Label>
                  <Input id="forgot-email" data-testid="forgot-email-input" type="email" required
                    value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <Button type="submit" className="w-full bg-sky-700 hover:bg-sky-800" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? "Envoi…" : "Envoyer le lien"}
                </Button>
                <p className="text-center">
                  <Link to="/connexion" className="text-sm text-sky-700 hover:underline" data-testid="back-to-login-link">
                    Retour à la connexion
                  </Link>
                </p>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
